class CompareProduct {
  constructor() {
    this.storageKey = 'm-compare-products'
    this.products = []
    this.productNodes = {}

    this.pageTemplate = 'page.product-compare'
    this.addedClass = 'added-to-compare'

    this.selectors = {
      container: '.m-compare-page-content__wrapper',
      noProducts: '.m-compare-no-products',
      wrapper: '.m-compare-card',
      item: '.m-product-card',
      compareButton: '.m-compare-button',
      compareText: '.m-compare-button-text',
      removeButton: '.m-compare-remove-button',
      count: '.m-compare-count'
    }

    this.products = Array.from(new Set(JSON.parse(localStorage.getItem(this.storageKey)) || []))
    this.isComparePage = MinimogSettings.template === this.pageTemplate

    this.init()
  }

  init = () => {
    if (this.isComparePage) {
      this.renderComparePage()
      this.addEventToRemoveButtons()
    }
    this.setCompareButtonsState()
    this.addEventToCompareButtons()
    this.updateCompareCount()
  }

  saveToStorage = () => {
    this.products = Array.from(new Set(this.products))
    localStorage.setItem(this.storageKey, JSON.stringify(this.products))
  }

  addToCompare(handle) {
    if (handle && this.products.indexOf(handle) === -1) {
      this.products.push(handle)
      this.saveToStorage()
    }
  }

  removeFromCompare(handle) {
    this.products = this.products.filter(hdl => hdl !== handle)
    this.saveToStorage()
  }

  setCompareButtonsState = () => {
    const buttons = document.querySelectorAll(this.selectors.compareButton)
    buttons.forEach(btn => {
      const prodHandle = btn?.dataset.productHandle
      if (this.products.indexOf(prodHandle) >= 0 && !btn.classList.contains(this.addedClass)) {
        this.toggleButtonState(btn, true)
      }
    })
  }

  updateCompareCount = () => {
    const size = this.products.length
    const countElems = document.querySelectorAll(this.selectors.count)

    countElems.forEach(elem => {
      elem.textContent = size
      elem.classList.toggle('m:hidden', size < 1)
    })
  }

  addEventToCompareButtons = () => {
    addEventDelegate({
      selector: this.selectors.compareButton,
      handler: (e, btn) => {
        e.preventDefault()

        const productHandle = btn?.dataset.productHandle
        if (!productHandle) return

        const active = !btn.classList.contains(this.addedClass)

        const wasAddedBefore = this.products.includes(productHandle)

        this.toggleButtonState(btn, active)
        this.updateCompareCount()

        document.querySelectorAll(this.selectors.compareButton).forEach(btnItem => {
          if (btnItem.dataset.productHandle === productHandle && btnItem !== btn) {
            const isAdded = !btnItem.classList.contains(this.addedClass)
            this.toggleButtonState(btnItem, isAdded)
          }
        })

        // ✅ Correct redirect URL
        if (active && !wasAddedBefore && this.products.length >= 2) {
          setTimeout(() => {
            window.location.href = '/pages/compare-products'
          }, 500)
        }
      }
    })
  }

  toggleButtonState = (btn, active) => {
    const productHandle = btn?.dataset.productHandle
    const compareText = btn?.querySelector(this.selectors.compareText)

    if (active) {
      this.addToCompare(productHandle)
      btn.classList.add(this.addedClass)
    } else {
      this.removeFromCompare(productHandle)
      btn.classList.remove(this.addedClass)
    }

    if (compareText) {
      const temp = compareText.dataset.revertText
      compareText.dataset.revertText = compareText.textContent
      compareText.textContent = temp
    }
  }

  addEventToRemoveButtons = () => {
    addEventDelegate({
      selector: this.selectors.removeButton,
      handler: (e, btn) => {
        e.preventDefault()

        const prod = btn.closest(this.selectors.wrapper)
        prod?.remove()

        const productHandle = btn.dataset.productHandle
        if (productHandle) {
          this.removeFromCompare(productHandle)
          this.updateCompareCount()

          if (!this.products.length) {
            this.showNoProductsMessage()
          }
        }
      }
    })
  }

  renderComparePage = async () => {
    const container = document.querySelector(this.selectors.container)
    if (!container) return

    let noItemAvailable = true

    if (this.products.length) {
      const promises = this.products.map(async hdl => {
        const prodHTML = await fetchCache(`/products/${hdl}?view=compare`)
        const item = document.createElement("div")

        item.classList.add("m:hidden", "m:column", "m-compare-card")
        item.innerHTML = prodHTML

        if (item.querySelector(this.selectors.item)) {
          noItemAvailable = false
          this.productNodes[hdl] = item
        }
      })

      await Promise.all(promises)

      this.products.forEach(hdl => {
        const prodNode = this.productNodes[hdl]
        if (prodNode) {
          container.appendChild(prodNode)
          prodNode.classList.remove('m:hidden')
        }
      })
    }

    if (noItemAvailable) {
      this.showNoProductsMessage()
    }

    container.classList.add('is-visible')
  }

  showNoProductsMessage = () => {
    const container = document.querySelector(this.selectors.container)
    const noProducts = document.querySelector(this.selectors.noProducts)

    container?.classList.add('m:hidden')
    noProducts?.classList.remove('m:hidden')
  }
}

MinimogTheme.CompareProduct = new CompareProduct()